import { render, staticRenderFns } from "./TermoDados.vue?vue&type=template&id=0ac34ed4"
import script from "./TermoDados.vue?vue&type=script&lang=js"
export * from "./TermoDados.vue?vue&type=script&lang=js"
import style0 from "./TermoDados.vue?vue&type=style&index=0&id=0ac34ed4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports